import { IAdRecommendResponse } from './types';

const recomendCache: {[key: string]: IAdRecommendResponse} = {};

export function getRecommendCacheByUrl(url: string) {
  return recomendCache[url];
}

export function setRecommendCache(url: string, response: IAdRecommendResponse) {
  recomendCache[url] = response;
}
